@if(!item) {
<mat-dialog-content>
  <span>Loading Item</span>
</mat-dialog-content>
} @else {
<div mat-dialog-title>
  <div class="flex flex-row justify-between items-center">
    <h1 class="m-0" data-cy="item-dialog-title">
      {{ item?.code }} - {{ item?.product.name }}
    </h1>
    <h1 class="text-sm text-slate-500 ml-4 flex flex-row justify-start items-center gap-x-1">
      @if (availableToHire) {
      <span class="text-green-500">Available ({{ item?.location | locationNameFromId | async }})</span>
      } @else {
      <span class="text-red-500">Unavailable</span>
      <mat-icon [matTooltip]="unavailableReason" class="text-gray-300">help
      </mat-icon>
      }
    </h1>
  </div>
</div>

<mat-dialog-content>
  <mat-tab-group class="flex flex-grow flex-shrink" [selectedIndex]="selectedTabIndex">
    <mat-tab label="Overview">
      <div class="my-4">
        <app-item-summary-tab [itemId]="item.id" (selectTab)="setSelectedTab($event)"></app-item-summary-tab>
      </div>
    </mat-tab>
    <mat-tab label="Hire history">
      <ng-template matTabContent>
        <app-hire-history-table [itemId]="item?.id" [productId]="item.product_id"></app-hire-history-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="Attributes">
      <div class="my-4">
        <ng-template matTabContent>
          <app-item-attributes [itemId]="item.id"></app-item-attributes>
        </ng-template>
      </div>
    </mat-tab>
    <mat-tab label="Attachments">
      <div class="py-4">
        <ng-template matTabContent>
          <app-item-attachments [itemId]="item.id"></app-item-attachments>
        </ng-template>
      </div>
    </mat-tab>
    <mat-tab label="Workshop history">
      <div class="py-4">
        <ng-template matTabContent>
          <app-workshop-job-history-list [data]="{ type: 'item', id: item.id }"
            [dialogRef]="dialogRef"></app-workshop-job-history-list>
        </ng-template>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="hireItem()" [disabled]="
  !availableToHire" data-cy="hire-item" [matTooltip]="unavailableReason">
    Hire this item
  </button>
  <button mat-raised-button (click)="goToProduct()">View Product</button>
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
}